import React from "react"
import { Link } from "react-router-dom"
import { SmartDateFormat } from "../../util/dates"
import { isMobile } from "react-device-detect"

interface Concert {
  id: number
  title: string
  title_cleaned?: string
  post_type_nice?: string
  band_name: string
  start_dt: string
  venue_name?: string
  cover_image_url?: string
  band_cover_photo_url_medium?: string
  already_happened?: boolean
  nada_path: string
}

interface ConcertSearchResultProps {
  concert: Concert
}

export const ConcertSearchResult: React.FC<ConcertSearchResultProps> = ({
  concert,
}) => {
  const defaultBgImageUrl =
    "https://bandnada.s3.amazonaws.com/static/external_assets/web/bandnada_dysentery.png"
  const imgStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  }
  const bgImgStyle: React.CSSProperties = {
    width: "100%",
    height: isMobile ? "200px" : "unset",
    aspectRatio: "16 / 9",
    background: `url(${concert.band_cover_photo_url_medium || defaultBgImageUrl})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  }

  return (
    <li
      className="col-span-1"
      style={{ height: isMobile ? "100%" : "max-content" }}
    >
      <Link to={concert.nada_path}>
        {concert.cover_image_url ? (
          <div
            className="w-full overflow-hidden bg-black"
            style={{ aspectRatio: "16/9" }}
          >
            <img
              src={concert.cover_image_url}
              alt={concert.title_cleaned || concert.title}
              className="cursor-pointer w-full h-full object-cover"
              style={imgStyle}
            />
          </div>
        ) : (
          <>
            <div
              className="w-full h-full bg-black text-white flex flex-col justify-end overflow-hidden"
              style={bgImgStyle}
            >
              <div className="text-xl leading-none pb-1 pl-1 bg-black opacity-75">
                {concert.title_cleaned || concert.title}
              </div>
            </div>
          </>
        )}
        <div className="font-bold leading-tight text-black-800">
          {concert.title_cleaned || concert.title}
        </div>
        {concert.post_type_nice && (
          <div className="font-medium leading-tight text-gray-600 text-xs uppercase">
            {concert.post_type_nice} - {concert.band_name}
          </div>
        )}
        <div className="text-gray-800 text-sm leading-tight">
          <span>
            {SmartDateFormat({
              dateStr: concert.start_dt,
              includeTime: !concert.already_happened,
            })}
          </span>{" "}
          {concert.venue_name && `at ${concert.venue_name}`}
        </div>
      </Link>
    </li>
  )
}
